import API from '@/lib/API.js'
import comun from './comun.js'
const lineaslaboratorio = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getLineas();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Lineas_Laboratorio.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_linealaboratorio == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_linealaboratorio: 0,
                id_solic: 0,
                id_practica: 0,
                estado: 1
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_linealaboratorio != 0) {
                data = await API.Lineas_Laboratorio.modificar(state.Seleccionado);
                str += "Laboratorio modificado"
            } else {
                data = await API.Lineas_Laboratorio.alta(state.Seleccionado);
                str += `Nuevo laboratorio de alta`
            }
            // let secs = await API.Lineas_Laboratorio.traerTodos();
            // commit("set", secs)
            // dispatch("selectPorId", data.id_linealaboratorio)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_linealaboratorio != 0) {
                data = await API.Lineas_Laboratorio.modificar(entidad);
                str += "Laboratorio modificado"
            } else {
                data = await API.Lineas_Laboratorio.alta(entidad);
                str += `Nuevo laboratorio de alta'`
            }
            // let secs = await API.Lineas_Laboratorio.traerTodos();
            // commit("set", secs)
            // dispatch("selectPorId", data.id_linealaboratorio)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Lineas_Laboratorio.eliminar(id);
                str += "Linea eliminada"
            }
            // let ents = await API.Lineas_Laboratorio.traerPorId();
            // commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getLineas: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default lineaslaboratorio;